import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import './style.scss'

export default class Button extends Component {
    static propTypes = {
        active: PropTypes.bool,
        buttonKey: PropTypes.string.isRequired,
        buttonText: PropTypes.oneOfType([PropTypes.node, PropTypes.string]),
        clickHandler: PropTypes.func,
        disabled: PropTypes.bool,
        mouseEnterHandler: PropTypes.func,
        mouseLeaveHandler: PropTypes.func,
    }

    static defaultProps = {
        active: false,
        disabled: false,
    }

    handleOnMouseEnter = () => {
        const { mouseEnterHandler, buttonKey } = this.props

        if (mouseEnterHandler) {
            mouseEnterHandler(buttonKey)
        }
    }

    handleOnMouseLeave = () => {
        const { mouseLeaveHandler, buttonKey } = this.props

        if (mouseLeaveHandler) {
            mouseLeaveHandler(buttonKey)
        }
    }

    handleGroupButtonClick = () => {
        const { clickHandler, buttonKey } = this.props

        if (clickHandler) {
            clickHandler(buttonKey)
        }
    }

    render() {
        const { buttonText, buttonKey, disabled, active } = this.props

        return (
            <button
                className={cx(`group-stack-header-button ${buttonKey}`, {
                    'is-disabled': disabled,
                    'is-active': active,
                })}
                disabled={disabled}
                onClick={this.handleGroupButtonClick}
                onMouseEnter={this.handleOnMouseEnter}
                onMouseLeave={this.handleOnMouseLeave}
            >
                {buttonText || ''}
            </button>
        )
    }
}
